module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart":"График","info":"Информация"},"en":{"chart":"Chart","info":"Info"}}')
  delete Component.options._Ctor
}
